/**
 * @generated SignedSource<<326c03d8d3ccd3e259c3f419adcfb50a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ModifyPlaylistButtons_Playlist$data = {
  readonly confluence_getPlaylist: {
    readonly tracks: {
      readonly nodes: ReadonlyArray<{
        readonly mainContent: {
          readonly id: string | null | undefined;
        } | null | undefined;
      }>;
    };
  } | null | undefined;
  readonly " $fragmentType": "ModifyPlaylistButtons_Playlist";
};
export type ModifyPlaylistButtons_Playlist$key = {
  readonly " $data"?: ModifyPlaylistButtons_Playlist$data;
  readonly " $fragmentSpreads": FragmentRefs<"ModifyPlaylistButtons_Playlist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ModifyPlaylistButtons_Playlist",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "ConfluencePlaylist",
      "kind": "LinkedField",
      "name": "confluence_getPlaylist",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluencePaginatedTracks",
          "kind": "LinkedField",
          "name": "tracks",
          "plural": false,
          "selections": [
            {
              "concreteType": "ConfluenceTrack",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "concreteType": "Content",
                  "kind": "LinkedField",
                  "name": "mainContent",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "id"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "32a93e686d27fab9e3f0a2aac68af56d";

export default node;
